export const PRIMARY_COLORS_VARIANTS = {
  100: '#FFFDF0',
  200: '#FFF8E5',
  300: '#FFDF86',
  400: '#ffefaf',
  450: '#ffb347',
  500: '#FFC107',
  550: '#ffcc00',
  600: '#d1a214',
  650: '#cc9900',
  700: '#b38600',
} as const

export const LIGHT_COLORS_VARIANTS_OPACITY = {
  50: '#ffffff1a',
  750: '#ffffffcc',
  1050: '#1b223280',
} as const

export const PRIMARY_COLORS_VARIANTS_OPACITY = {
  300: '#ffcc0033',
  550: '#ffcc00cc',
} as const

export const NEGATIVE_COLORS_VARIANTS = {
  200: '#ef44441a',
  400: '#F37575',
} as const

export const TEXT_DARK_COLORS_VARIANTS = {
  150: '#e5e7eb',
  200: '#888c94',
  250: '#5c6370',
  280: '#6b7280',
  300: '#6b727f',
  350: '#91949c',
  400: '#1b2232',
  500: '#000000',
} as const

export const BLUE_DARK_COLORS_VARIANTS = {
  50: '#d1d6e0',
  100: '#e0e4eb',
  200: '#2d3543',
  250: '#36363980',
  300: '#2d3e53',
  350: '#16213e',
  400: '#1b2232',
  450: '#0F1E27',
} as const

export const GREEN_COLORS_VARIANTS = {
  250: '#dcfce7',
  300: '#bbf7d0',
  450: '#46c64ff5',
  500: '#46c64f',
  550: '#25D366',
  600: '#10B981',
  700: '#15803d',
  800: '#14532d',
  950: '#052e16',
} as const

export const RED_COLORS_VARIANTS = {
  250: '#fee2e2',
  300: '#fecaca',
  450: '#f87171f5',
  500: '#e53935',
  600: '#dc2626',
} as const

export const BLUE_COLORS_VARIANTS = {
  300: '#d9dcfa',
  500: '#0e23dd',
} as const

export const GREEN_COLORS_VARIANTS_OPACITY = {
  500: '#15803d4d',
  950: '#052e1699',
} as const

export const GRAY_COLORS_VARIANTS = {
  50: '#f9fafb',
  100: '#f3f4f6',
  200: '#e5e7eb',
} as const

export const LIVE_INDICATOR_COLOR = '#e53935'

export const SLATE_COLORS_VARIANTS = {
  200: '#E2E8F0',
  300: '#CBD5E1',
  500: '#64748B',
  600: '#475569',
  900: '#0F172A',
} as const

export const CYAN_COLORS_VARIANTS = {
  400: '#36E0F6',
  500: '#20CBE2',
} as const

export const ORANGE_COLORS_VARIANTS = {
  400: '#F0B040',
  500: '#FFA500',
} as const

export const CREAM_COLORS_VARIANTS = {
  100: '#FAF6ED',
} as const
